import React from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { ProjectSettingsMenuChoices } from '../../ProjectSettingsPage/ProjectSettingsPage';
import { ProjectTabChoices } from '../ProjectPage';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import GotToEditLink from './GotToEditLink';

export interface ProjectNameIndicatorProps {
  project: ProjectGq;
}

export const ProjectNameIndicator: React.FC<ProjectNameIndicatorProps> = ({ project }) => {
  const settingsUrl = `/${project.id}/${ProjectTabChoices.Settings}/${ProjectSettingsMenuChoices.General}#name`;

  return (
    <VoxelTooltipShort message="Rename project">
      <GotToEditLink className="h-6 font-semibold text-sm text-voxel-gray-700" href={settingsUrl} hasError={!project.name.length}>
        <span className="truncate max-w-[240px] sm:max-w-[300px] md:max-w-[340px] lg:max-w-[440px] xl:max-w-[500px] 2xl:max-w-[600px]">
          {project.name?.length ? project.name : 'No project name'}
        </span>
      </GotToEditLink>
    </VoxelTooltipShort>
  );
};

export default ProjectNameIndicator;
